import { Media } from './media';

export interface MediaData extends Media {
  url: string;
  showProcessing?: boolean;
  isUploading?: boolean;
  uploadProgress?: number;
}
